import { useMemo, useState } from "react";
import Select from "react-select";
import SimpleModalFooter from "app/components/Modals/SimpleModalFooter";
import { useAppSelector } from "utils/redux/hooks";
import {
  selectAdditionalFields,
  selectGetAdditionalFieldsStatus,
} from "../slice";
import { AdditionalFieldSelection } from "../types";

interface Props {
  onBack: () => void;
  onSave: (fieldSelection: AdditionalFieldSelection) => void;
}

const AdditionalFieldEmailConfig = ({ onBack, onSave }: Readonly<Props>) => {
  const additionalFields = useAppSelector(selectAdditionalFields);
  const getAdditionalFieldsStatus = useAppSelector(
    selectGetAdditionalFieldsStatus
  );
  const [selectedFieldName, setSelectedFieldName] = useState<string | null>(
    null
  );
  const [selectedFieldValue, setSelectedFieldValue] = useState<string | null>(
    null
  );
  const selectedField = useMemo(
    () =>
      additionalFields?.find((field) => field.fieldName === selectedFieldName),
    [additionalFields, selectedFieldName]
  );

  const onFieldNameChange = (value: string | null) => {
    setSelectedFieldName(value);
    setSelectedFieldValue(null);
  };

  return (
    <>
      <Select
        isLoading={getAdditionalFieldsStatus === "loading"}
        placeholder="Select field"
        options={(additionalFields ?? []).map((field) => ({
          label: field.fieldName,
          value: field.fieldName,
        }))}
        value={
          selectedFieldName
            ? { label: selectedFieldName, value: selectedFieldName }
            : null
        }
        onChange={(option) => onFieldNameChange(option?.value ?? null)}
      />
      <Select
        isDisabled={!selectedField}
        placeholder="Select value"
        options={(selectedField?.values ?? []).map((value) => ({
          label: value,
          value,
        }))}
        value={
          selectedFieldValue
            ? { label: selectedFieldValue, value: selectedFieldValue }
            : null
        }
        onChange={(option) => setSelectedFieldValue(option?.value ?? null)}
      />
      <SimpleModalFooter
        onBackButtonClick={onBack}
        onPrimaryButtonClick={() => {
          if (!selectedFieldName || !selectedFieldValue) return;
          onSave({
            fieldName: selectedFieldName,
            fieldValue: selectedFieldValue,
          });
        }}
        isPrimaryButtonDisabled={!selectedFieldName || !selectedFieldValue}
        primaryButtonText="Next"
      />
    </>
  );
};

export default AdditionalFieldEmailConfig;
